<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-select
          v-model="inputPathname"
          :items="pageOptions"
          label="Select Page"
          item-title="name"
          item-value="pathname"
          clearable
          class="mb-4"
        ></v-select>
      </v-col>
    </v-row>

    <v-card v-if="page" class="pa-4">
      <v-card-title class="text-h4 mb-4">{{ formatPageName(page.pathname) }}</v-card-title>
      
      <v-card-text>
        <div class="text-body-1"><strong>Meta Title:</strong> {{ page.metaTitle }}</div>
        <div class="text-body-1"><strong>Meta Description:</strong> {{ page.metaDescription }}</div>

        <v-divider class="my-4"></v-divider>

        <h2 class="text-h5 mb-2">Description</h2>
        <div class="text-body-1">{{page.description.descriptionHtml}}</div>

        <v-divider class="my-4"></v-divider>

        <h2 class="text-h5 mb-2">Images</h2>
        <v-row>
          <v-col v-for="(image, index) in page.description.images" :key="index" cols="12" sm="6" md="4">
            <v-img :src="image.src" :alt="image.alt" height="200" contain></v-img>
            <div class="text-caption mt-2">Type: {{ image.type }}</div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="openPage">
          Open Page
        </v-btn>
        <v-btn color="secondary" @click="copySource">
          Copy Source
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-alert v-else-if="inputPathname && !page" type="warning" class="mt-4">
      No page found for pathname: "{{ inputPathname }}"
    </v-alert>
  </v-container>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue';
import { usePagesStore } from '@/store/pagesStore';
import { useUrlSourcesStore  } from '@/store/urlSourcesStore';
import UrlSourceTypes from '@/enums/UrlSourceTypes';
import { useActiveUrlStore } from '@/store/activeUrlStore';

const pagesStore = usePagesStore();
const activeUrlStore = useActiveUrlStore();
const urlSourcesStore = useUrlSourcesStore ();
const url = activeUrlStore.activeUrl;
const inputPathname = ref<string>('');

const pageOptions = computed(() => 
urlSourcesStore.getAllPathnamesByType(UrlSourceTypes.PAGE)
    .map(path => ({
      pathname: path,
      name: formatPageName(path)
    }))
);

const page = computed(() =>
  inputPathname.value ? pagesStore.getPageByPathname(inputPathname.value) : undefined
);

function formatPageName(path: string): string {
  return path
    .replace('/pages/', '')
    .replace('.php', '')
    .replace(/-/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase());
}

function openPage() {
  if (url && page.value) {
    window.open(`${url}${page.value.pathname}`, '_blank');
  }
}

// Copies the URL source to the clipboard
async function copySource() {
  const source = urlSourcesStore.getSourceByPathname(inputPathname.value);
  if (source) {
    try {
      await navigator.clipboard.writeText(source);
      console.log('Source copied to clipboard');
    } catch (err) {
      console.error('Failed to copy source to clipboard:', err);
    }
  }
}
</script>